import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    ACCOUNT_DELETED,
    SET_LOADING,
    UNSET_LOADING,
    USER_PERMISSIONS_LOADED,
    USER_PERMISSIONS_ERROR
} from '../actions/types';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: true,
    loading: true,
    user: null,
    permissions: {
        pages: [],
        ungrouped_permissions: [],
        all_permissions: []
    }
};

export default function (state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case SET_LOADING:
            return {
                ...state,
                loading: false
            };
        case UNSET_LOADING:
            return {
                ...state,
                loading: false
            };
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload,
            };
        case USER_PERMISSIONS_LOADED:
            return {
                ...state,
                permissions: payload
            };
        case USER_PERMISSIONS_ERROR:
            return {
                ...state,
                permissions: {
                    pages: [],
                    ungrouped_permissions: [],
                    all_permissions: []
                }
            };
        case REGISTER_SUCCESS:
        case LOGIN_SUCCESS:
            localStorage.setItem('token', payload.token);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
            };
        case REGISTER_FAIL:
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGOUT:
        case ACCOUNT_DELETED:
            localStorage.removeItem('token');
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: false,
                user: null,
                permissions: {
                    pages: [],
                    ungrouped_permissions: [],
                    all_permissions: []
                }
            };
        default:
            return state;
    }
}
